// CommonJS format, because shared with serverless 'funcs',
// which doesn't go through webpack/babel transpilation,
// which also means no importing from helpers etc..


/*
 * iframely (embed)
 */
const IFRAMELY_API_ENDPOINT = "https://iframe.ly/api/iframely"
const IFRAMELY_API_KEY = "30da92d1be3bdd3b7fce18"

// As a result of `funcs/render-iframely-embed` (must update if changed!)
const RENDER_IFRAMELY_EMBED_DOMAIN = "https://67gxd21n30.execute-api.us-east-1.amazonaws.com"

// Relay back to IFRAMELY_API_ENDPOINT, but with an ability to take a screenshot.
const lambdaStage = process.env.NODE_ENV === 'production' ? 'production' : 'staging'
const IFRAMELY_RELAY_ENDPOINT = RENDER_IFRAMELY_EMBED_DOMAIN + "/" + lambdaStage


module.exports = {
  IFRAMELY_API_ENDPOINT,
  IFRAMELY_API_KEY,
  IFRAMELY_RELAY_ENDPOINT,
}



// WEBPACK FOOTER //
// ./src/shared/constants/external.js